/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export enum Operator {
  EQUAL = "EQUAL",
  NOT_EQUAL = "NOT_EQUAL",
  LESS_THAN = "LESS_THAN",
  GREATER_THAN = "GREATER_THAN",
  COUNT_EQUAL = "COUNT_EQUAL",
  COUNT_GREATER_THAN = "COUNT_GREATER_THAN",
  COUNT_LESS_THAN = "COUNT_LESS_THAN",
  EXISTS = "EXISTS",
  NOT_EXISTS = "NOT_EXISTS",
  IN_GROUP = "IN_GROUP",
  NOT_IN_GROUP = "NOT_IN_GROUP",
  MATCHES = "MATCHES",
  NOT_MATCHES = "NOT_MATCHES",
  CONTAINS = "CONTAINS",
  NOT_CONTAINS = "NOT_CONTAINS"
}
